;(function () {
  // tb-variant-picker

  console.log("tb-variant-picker")
  // color variants
  if (document.querySelector(".variant-picker-color") !== null) {
    console.log("variant-picker-color")
    let initTooltips = function () {
      jQuery(".tb-tooltip-toggle").tooltip({
        position: {
          my: "center top+15",
          at: "center bottom",
          using: function (position, feedback) {
            $(this).css(position)
            $("<div>")
              .addClass("tb-tooltip")
              .addClass(feedback.vertical)
              .addClass(feedback.horizontal)
              .appendTo(this)
          },
        },
      })
    }
    let jqIntr = setInterval(function () {
      if (
        typeof jQuery === "function" &&
        typeof jQuery().tooltip === "function"
      ) {
        initTooltips()
        clearInterval(jqIntr)
      }
    }, 500)
  }

  // size variants
  if (document.querySelector(".variant-picker-size") !== null) {
    console.log("variant-picker-size")
    let initPopup = function () {
      // open popup click
      document
        .querySelector(
          ".product-sizechart-wrapper .product-sizechart-popup-link",
        )
        .addEventListener("click", (event) => {
          event.preventDefault()
          // reset cm / in state
          let $toggler = jQuery(".product-sizechart-wrapper #sizeUnitsToggler")
          let $in = jQuery(".product-sizechart-wrapper table .in")
          let $cm = jQuery(".product-sizechart-wrapper table .cm")
          if ($toggler.is(":checked")) {
            $cm.show()
            $in.hide()
          } else {
            $in.show()
            $cm.hide()
          }
          // show popup
          document
            .querySelector(
              ".product-sizechart-wrapper .product-sizechart-popup",
            )
            .classList.add("active")
          // prevent scrolling
          document.body.classList.add("overflow-hidden")
          // scroll to top of popup
          document.querySelector(".product-sizechart-popup-content").scrollTop =
            0
        })
      // close popup click
      document
        .querySelector(
          ".product-sizechart-wrapper .product-sizechart-popup-close",
        )
        .addEventListener("click", (event) => {
          document
            .querySelector(
              ".product-sizechart-wrapper .product-sizechart-popup",
            )
            .classList.remove("active")
          document.body.classList.remove("overflow-hidden")
          document
            .querySelector(".product-sizechart-wrapper #sizeUnitsForm")
            .reset()
        })
      // size units (in/cm) toggler
      document
        .querySelector(".product-sizechart-wrapper #sizeUnitsToggler")
        .addEventListener("click", (event) => {
          let $toggler = jQuery(event.target)
          let $in = jQuery(".product-sizechart-wrapper table .in")
          let $cm = jQuery(".product-sizechart-wrapper table .cm")
          let $cm_in = jQuery(
            ".product-sizechart-wrapper table .cm:visible,.product-sizechart-wrapper table .in:visible",
          )
          $cm_in.fadeOut(200, () => {
            if ($toggler.is(":checked")) {
              $cm.fadeIn(200)
            } else {
              $in.fadeIn(200)
            }
          })
        })
    }
    initPopup()
  }
})()
